export default "__VITE_ASSET__Wq_ar3yc__"